import { useMetrics } from "hooks/useMetrics";
import MetricsExtractor from "logic/metrics/MetricsExtractor";
const METRIC_PREFIX = "org.graylog.plugins.datalake.backend.local";
const metricNames = {
  totalBytes: `${METRIC_PREFIX}.total-space-bytes`,
  usagePercentage: `${METRIC_PREFIX}.usage-percentage`
};
const metricValues = Object.values(metricNames);
const getMetricValue = (nodeMetrics, metricName) => {
  if (!nodeMetrics) {
    return void 0;
  }
  const { value } = MetricsExtractor.getValuesForNode(nodeMetrics, { value: metricName });
  return typeof value === "number" && Number.isFinite(value) ? value : void 0;
};
const getFirstNonZeroValue = (metricsByNode, metricName) => {
  var _a;
  return (_a = Object.keys(metricsByNode != null ? metricsByNode : {}).map((nodeId) => getMetricValue(metricsByNode == null ? void 0 : metricsByNode[nodeId], metricName)).find((v) => v !== void 0 && v !== 0)) != null ? _a : 0;
};
const useDataLakeFSVolumeMetrics = () => {
  const { data: metricsByNode, isLoading } = useMetrics(metricValues);
  const totalBytes = getFirstNonZeroValue(metricsByNode, metricNames.totalBytes);
  const usagePercentage = getFirstNonZeroValue(metricsByNode, metricNames.usagePercentage);
  return {
    totalBytes,
    usagePercentage,
    isLoading,
    hasData: totalBytes > 0
  };
};
export default useDataLakeFSVolumeMetrics;
